export * from './VariablesIcon';
